// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18wnK","rootMobile":"styles_rootMobile__19y8x"};